package com.qrkontaq.ui.theme

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import kotlinx.browser.document
import org.jetbrains.compose.web.css.px

fun initAppTheme(ctx: InitSilkContext) {

    val fontFaceStyle = document.createElement("style") as org.w3c.dom.HTMLStyleElement
    fontFaceStyle.id = "custom-fonts-face"
    fontFaceStyle.textContent = """

        @font-face {
            font-family: 'GalakRound';
            src: url('/fonts/GalakRound-GalakProRegular.woff2') format('woff2');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }
        @font-face {
            font-family: 'GalakRound';
            src: url('/fonts/GalakRound-Medium.woff2') format('woff2');
            font-weight: 500;
            font-style: normal;
            font-display: swap;
        }

        @font-face {
            font-family: 'Gilroy';
            src: url('/fonts/Gilroy-Regular.woff2') format('woff2');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }
        @font-face {
            font-family: 'Gilroy';
            src: url('/fonts/Gilroy-Medium.woff2') format('woff2');
            font-weight: 500;
            font-style: normal;
            font-display: swap;
        }

        @font-face {
            font-family: 'Sansation';
            src: url('/fonts/SansationRegular.woff2') format('woff2');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
        }

        @font-face {
            font-family: 'Montserrat';
            src: url('/fonts/Montserrat-Bold.woff2') format('woff2');
            font-weight: 700;
            font-style: normal;
            font-display: swap;
        }
    """.trimIndent()
    document.head?.appendChild(fontFaceStyle)

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
            .fontSize(AppTypography.Body)
            .fontWeight(AppTypography.Regular)
            .margin(0.px)
            .padding(0.px)
    }

    // Mobile browsers flash a ripple-like highlight on every tap target;
    // our own press feedback (.qk-press) is the only touch response we want.
    ctx.stylesheet.registerStyleBase("*") {
        Modifier.styleModifier { property("-webkit-tap-highlight-color", "transparent") }
    }
}
